import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant10PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 628 876",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M334.717 70.3525C273.959 94.9687 208.509 116.636 156.864 157.961C110.759 194.863 69.7468 249.993 70.1489 312.494C70.4617 365.39 104.281 417.749 154.139 435.486C188.137 447.548 227.183 441.517 256.625 420.921C282.134 403.006 297.369 375.531 312.558 349.128C327.971 322.412 345.976 299.181 374.076 284.84C399.407 271.928 429.563 267.997 456.994 275.547C489.92 284.616 517.038 309.322 534.461 338.718C548.981 363.2 557.559 391.435 557.246 419.894C556.621 473.236 522.31 516.035 479.243 544.136C451.991 561.873 421.611 574.203 391.053 585.282C358.574 597.032 323.414 609.095 303.489 637.329C267.972 687.589 299.379 750.761 302.104 805.354",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant10PathwayIllustration as default };
